/* eslint-disable no-unused-vars */
import { createStore } from 'vuex'
// import shop2 from '@/api/nnw.json'
import shop2 from '@/api/nnc.json'
import Form from '@/components/form.js'
// import axios from 'axios'
export default createStore({
  state: {
    form: new Form({
      store_id: '',
      cart: [],
      cartTotal: 0,
      lieferkost: 0.0,
      gesammtkosten: 0.0,
      name: '',
      strasse: '',
      hausnummer: '',
      etasse: '0',
      plz: '',
      stadt: '',
      telefonnummer: '',
      email: '',
      orderType: 'Selbstabholung',
      lieferzeit: 'So schnell wie möglich',
      zahlungsmethode: 'Barzahlung',
      paymentMade: 0,
      lieferHinweis: 'keine'
    }),
    currentTime: 0,
    endTime: 0,
    endLunchTime: 0,
    showHeader: true,
    showPopupCart: false,
    zusatzText: '',
    lieferkost: 1.00,
    cartTotal: 0.0,
    gesammtkosten: 0.0,
    allProducts: [],
    gruppe: [],
    gruppenUrls: [],
    cart: [],
    showModal: false,
    isLunchTime: false,
    isDinnerTime: false,
    checkoutStatus: null,
    // zahlungsmethode: ['Barzahlung', 'ECkarte', 'Paypal'],
    zahlungsmethode: ['Barzahlung', 'Paypal'],
    orderType: ['Selbstabholung', 'Lieferung', 'Im Restaurant genießen']

  },
  getters: {
    getZahlungsmethode: state => state.zahlungsmethode,
    getOrderType: state => state.orderType,
    getForm: state => state.form,
    getShowHeader: state => state.showHeader,
    getPopupCart: state => state.showPopupCart,
    getLieferKosten: (state) => state.form.lieferkost,
    getGesammtKosten: state => state.form.gesammtkosten,
    getFormCartTotal: state => state.form.cartTotal,
    // getVegan: (state) => state.vegan,
    getAlleProdukte: (state) => {
      const _alleProdukute = state.allProducts
      return _alleProdukute.filter(product => product.inventory > 0)
    },
    getAllProducts: (state) => {
      const _alleProdukute = state.allProducts
      // console.log(_alleProdukute)
      return _alleProdukute
    },
    getProductByPosnr (getters, posnr) {
      return getters.getAllProducts.find(product => product.posnr === posnr)
    },

    getGruppe: (state) => {
      return state.gruppe
    },
    getGruppenUrls: (state) => {
      return state.gruppenUrls
    },

    // getCartProducts: (state, getters) => {
    getCartProducts: (state) => {
      // const products = getters.getAllProducts
      // update state.form.cart
      for (var i = 0; i < state.form.cart.length; i++) {
        if (state.form.cart[i].quantity === 0) {
          state.form.cart.slice(i, 1)
        }
      }
      // console.log('state.form.cart.length')
      // console.log(state.form.cart)
      return state.form.cart
      /** .map(cartItem => {
        const product = products.find(product => {
          var tfVec = false
          tfVec = product.posnr === cartItem.posnr
          // tfVec = tfVec && (product.curScharfeStufe === cartItem.curScharfeStufe)
          return tfVec
        })
        if (product) {
          product.quantity = cartItem.quantity
          product.zusatzText = cartItem.zusatzText
          product.curScharfeStufe = cartItem.curScharfeStufe
          product.curAuswahl = cartItem.curAsuwahl
          if (state.isLunchTime) {
            product.currentPrice = product.price1
          } else {
            product.currentPrice = product.price2
          }
          return product
        }
      })
      */
    },
    getCartTotal (state, getters) {
      // let total =0;
      // getters.getCartProducts.reduce(product => {
      //   console.log(product)
      //   //   total +=product.price*product.quantity;
      // }, 0)
      return getters.getCartProducts.reduce((total, product) => {
        // total = 0
        total = total + product.currentPrice * product.quantity
        return total
      }, 0)
    // return 1;
    },
    getTotalCartItems (state) {
      let i; let total = 0
      for (i = 0; i < state.form.cart.length; ++i) {
        total += state.form.cart[i].quantity
      }
      return total
      // return state.form.cart.reduce((total, product) => total + product.quantity, 0)
      // return 1;
    },
    getIsLunchTime (state) {
      return state.isLunchTime
    }
    // getCartItemQuantity ((state, getters), _posnr) {
    //   var products = state.form.cart
    //   var product = products.find(item => item.posnr === _posnr)
    //   return product.quantity
    // }

  },
  mutations: {
    SET_STORE_ID: (state, storeId) => {
      state.form.store_id = storeId
    },
    SET_DELEVERY_COST: (state, deleveryCost) => {
      state.form.lieferkost = deleveryCost
      state.form.gesammtkosten = state.form.cartTotal + deleveryCost
    },
    SET_CURRENT_TIME: (state) => {
      var d = new Date()
      state.currentTime = d.getMinutes() + d.getHours() * 60
    },
    SET_END_TIME: (state) => {
      state.endTime = 22 * 60 + 15
      state.endLunchTime = 14 * 60 + 30
    },
    SET_NAME: (state, name) => {
      state.form.name = name
    },
    SET_STRASSE: (state, strasse) => {
      state.form.strasse = strasse
    },
    SET_HAUSNUMMER: (state, hausnummer) => {
      state.form.hausnummer = hausnummer
    },
    SET_ETASSE: (state, etasse) => {
      state.form.etasse = etasse
    },
    SET_PLZ: (state, plz) => {
      state.form.plz = plz
    },
    SET_STADT: (state, stadt) => {
      state.form.stadt = stadt
    },
    SET_TELEFONNUMMER: (state, telefonnummer) => {
      state.form.telefonnummer = telefonnummer
    },
    SET_EMAIL: (state, email) => {
      state.form.email = email
    },
    SET_ORDERTYPE: (state, orderType) => {
      state.form.orderType = orderType
    },
    SET_LIEFERZEIT: (state, lieferzeit) => {
      state.form.lieferzeit = lieferzeit.toString()
    },
    SET_LIEFERHINWEIS: (state, lieferHinweis) => {
      state.form.lieferHinweis = lieferHinweis.toString()
    },
    SET_CART_TOTAL: (state, cartTotal) => {
      // console.log(state.form.cart)
      state.form.cartTotal = cartTotal
      state.form.gesammtkosten = state.form.cartTotal +
       state.form.lieferkost
    },
    SET_PAYMENTMADE: (state, tfValue) => {
      if (tfValue) {
        state.form.paymentMade = true
      } else {
        state.form.paymentMade = false
      }
    },
    SET_ZAHLUNGSMETHODE: (state, zahlungsmethode) => {
      state.form.zahlungsmethode = zahlungsmethode
    },
    DONOT_SHOW_HEADER: (state) => {
      state.showHeader = false
    },
    SHOW_HEADER: (state) => {
      state.showHeader = true
    },
    SHOW_POPUP_CART: (state) => {
      state.showPopupCart = !state.showPopupCart
    },
    updateMessage (state, indexMessage) {
      state.zusatzText = indexMessage.message
      // console.log(state.form.cart[indexMessage.index])
    },
    SET_PRODUCTS: (state, products) => {
      state.allProducts = products
    },
    SET_GRUPPE: (state, gruppe) => {
      state.gruppe = gruppe
    },
    SET_GRUPPEN_URLS: (state, gruppenUrls) => {
      state.gruppenUrls = gruppenUrls
    },
    PUSH_PRODUCT_TO_CART (state, selectedItems) {
      state.form.cart.push({
        posnr: selectedItems.posnr,
        name: selectedItems.name,
        currentPrice: selectedItems.currentPrice,
        productPortion: selectedItems.productPortion,
        productType: selectedItems.productType,
        quantity: selectedItems.quantity,
        zusatzText: '',
        curScharfeStufe: selectedItems.curScharfeStufe,
        currentAuswahl: selectedItems.currentAuswahl,
        ihreExtras: selectedItems.ihreExtras

      })
      // console.log('cart')
      // console.log(state.form.cart)
    },
    INCREMENT_CARTITEM_QUANTITY (state, increment) {
      state.form.cart[increment.cartIndex].quantity += increment.quantity
    },
    // ADD_CART_PRODUCT: (state, product) => {
    //   state.cartProducts.push(product)
    // },
    ADD_ZUSATZ_TEXT_IN_CART_ITEM: (state, indexMessage) => {
      state.form.cart[indexMessage.index].zusatzText = indexMessage.zusatzText
      // console.log(state.form.cart[indexMessage.index])
    },
    CHANGE_SCHARFESTUFE_IN_CART_ITEM: (state, indexMessage) => {
      state.form.cart[indexMessage.index].curScharfeStufe = indexMessage.curScharfeStufe
      // console.log(state.form.cart[indexMessage.index])
    },
    CHANGE_PRODUCT_PORTION_IN_CART_ITEM: (state, indexMessage) => {
      state.form.cart[indexMessage.index].productPortion = indexMessage.productPortion
      // console.log(state.form.cart[indexMessage.index])
    },
    CHANGE_PRODUCT_TYPE_IN_CART_ITEM: (state, indexMessage) => {
      state.form.cart[indexMessage.index].productType = indexMessage.productType
      // console.log(state.form.cart[indexMessage.index])
    },
    REMOVE_ZUSATZ_TEXT_IN_CART_ITEM: (state, index) => {
      state.form.cart[index].zusatzText = ''
      // console.log(state.form.cart[index])
    },
    REMOVE_CART_PRODUCT: (state, index) => {
      state.form.cart.splice(index, 1)
    },
    REDUCE_CART_ITEM_QUANTITY: (state, index) => {
      state.form.cart[index].quantity--
    },
    INCREASE_CART_ITEM_QUANTITY: (state, index) => {
      state.form.cart[index].quantity++
    },
    SHOW_MODAL: (state) => {
      state.showModal = !state.showModal
    },
    // SET_GETRENKE: (state) => {
    //   state.] = state.allProducts.filter((item) => item.gruppe.includes(']'))
    // },
    SET_VEGAN: (state) => {
      state.vegan = state.allProducts.filter((item) => item.gruppe.includes('Vegan'))
    },
    SET_LUNCH_TIME: (state, tfValue) => {
      state.isLunchTime = tfValue
    }
  },
  actions: {
    /** Helper functions
     *
     */
    // get the productByPosNR
    getProductByPosnr ({ state }, posnr) {
      var product = state.form.cart.find(product => product.posnr === posnr)
      // console.log(product)
      return product
    },
    getcartQuantity ({ state }, posnr) {
      var product = state.form.cart.find(product => product.posnr === posnr)
      console.log(product)
      return product.quantity
    },
    dontShowHeader: (context) => {
      context.commit('DONOT_SHOW_HEADER')
      // console.log(context.state.showHeader)
    },
    showHeader: (context) => {
      context.commit('SHOW_HEADER')
    },
    showOrHiddenPopupCart: (context) => {
      context.commit('SHOW_POPUP_CART')
    },
    addZusatzTextInCartItem (context, indexMessage) {
      context.commit('ADD_ZUSATZ_TEXT_IN_CART_ITEM', indexMessage)
      context.commit('CHANGE_SCHARFESTUFE_IN_CART_ITEM', indexMessage)
      context.commit('CHANGE_PRODUCT_PORTION_IN_CART_ITEM', indexMessage)
      context.commit('CHANGE_PRODUCT_TYPE_IN_CART_ITEM', indexMessage)
    },
    removeZusatzTextInCartItem (context, index) {
      context.commit('REMOVE_ZUSATZ_TEXT_IN_CART_ITEM', index)
    },
    reduceCartItemQuantity (context, index) {
      // eslint-disable-next-line space-before-blocks
      // console.log('context.state.form.cart[index]')
      // console.log(context.state.form.cart[index].quantity)
      context.commit('REDUCE_CART_ITEM_QUANTITY', index)
      if (context.state.form.cart[index].quantity === 0) {
        context.commit('REMOVE_CART_PRODUCT', index)
      }
      context.commit('SET_CART_TOTAL', context.getters.getCartTotal)
    },
    increaseCartItemQuantity (context, index) {
      context.commit('INCREASE_CART_ITEM_QUANTITY', index)
      context.commit('SET_CART_TOTAL', context.getters.getCartTotal)
    },
    getUniqueArray: (value, index, self) => {
      return self.indexOf(value) === index
    },
    removeProductFromCart: (context, index) => {
      context.commit('REMOVE_CART_PRODUCT', index)
      context.commit('SET_CART_TOTAL', context.getters.getCartTotal)
    },

    addProductToCart: ({ getters, state, commit }, selectedItems) => {
      if (selectedItems.inventory > 0) {
        const cartItem = state.form.cart.find(item => {
          var tfVec = false
          tfVec = (item.posnr === selectedItems.posnr)
          tfVec = tfVec && (item.curScharfeStufe === selectedItems.curScharfeStufe)
          tfVec = tfVec && (item.currentAuswahl === selectedItems.currentAuswahl)
          tfVec = tfVec && (item.productPortion === selectedItems.productPortion)
          tfVec = tfVec && (item.productType === selectedItems.productType)
          return tfVec
        }) // console.log(cartItem)
        if (!cartItem) {
          commit('PUSH_PRODUCT_TO_CART', selectedItems)
          // console.log('selectedItems')
          // console.log(selectedItems.quantity)
        } else {
          /** first check if all the Selected Items are equal.
           * If so then just add the quantity.
          **/
          /** if selected  items are different then push a new cart Item. */
          // console.log('compare sarfstufe')
          // console.log(cartItem)
          // console.log(selectedItems)
          // if (cartItem.curScharfeStufe === selectedItems.curScharfeStufe) {
          //   commit('INCREMENT_CARTITEM_QUANTITY', cartItem)
          // } else {
          var increment = {
            quantity: selectedItems.quantity,
            cartIndex: state.form.cart.indexOf(cartItem)

          }
          commit('INCREMENT_CARTITEM_QUANTITY', increment)
          // console.log('state.form.cart.quantity ' + state.form.cart.quantity)
          // console.log('state.form.cart prodcut: ' + product.posnr)
          // console.log('state.form.cart: ' + state.form.cart.length)

        /** *Reduce the inventary by one as this is sold out by one times.
           DECREMENT_PRODUCT_INVENTORY(state,product){
          product.inventory--;
          **/
        }
        // state.form.cartTotal += cartItem.quantity * cartItem.currentPrice
        // state.form.gesammtkosten = state.form.cartTotal + state.form.lieferkost
        commit('SET_DELEVERY_COST', getters.getLieferKosten)
        commit('SET_CART_TOTAL', getters.getCartTotal)
        // console.log(getters.getCartTotal)
        // commit('SET_GESAMMT_KOSTEN', selectedItems.gesammtkosten)
      }
    },
    setLunchTime ({ state, commit }) {
      // var et = '14:30:00'
      var d = new Date()
      var curTime = d.getMinutes() + d.getHours() * 60
      var endTime = 14 * 60 + 30
      var startTime = 10 * 60 + 30
      var eveEndTime = 22 * 60 + 0
      // console.log('current Time ' + curTime + ' End time :' + endTime)
      var tfValue = (startTime <= curTime) && (curTime <= endTime)
      commit('SET_LUNCH_TIME', tfValue)
      commit('SET_CURRENT_TIME')
      commit('SET_END_TIME')
      return tfValue
    },
    // removeProductFromCart: (context, index) => {
    //   context.commit('REMOVE_CART_PRODUCT', index)
    // },
    createUrl: (url) => {
      return url.replace(' ', '-').trim()
    },
    fetchProducts ({ commit }) {
      // you can also pass context . context is just like store.
      // then you can write context.commit
      return new Promise(
        (resolve) => {
          // we have imported shop from @/asset/shop1.js file
          // and used here.
          shop2.getProducts(
            products => {
              // console.log(products)
              commit('SET_PRODUCTS', products)
              // set Article Groups
              var gruppe = ['Home', 'Vorspeise', 'Haupt Gerichte', 'Getr&#228;nke', 'Speise']
              for (var i = 0; i < products.length; ++i) {
                var gruppe1 = products[i].gruppe
                // console.log(gruppe1)
                if (gruppe.length > 0) {
                  gruppe = [...gruppe, ...gruppe1]
                } else {
                  gruppe = gruppe1
                }
              }
              var gruppe2 = gruppe.filter((item, index) => gruppe.indexOf(item) === index)
              // console.log(gruppe2)
              commit('SET_GRUPPE', gruppe2)
              // create gruppen Urls
              var gruppenUrls = []
              for (var j = 0; j < gruppe2.length; ++j) {
                var url = gruppe2[j].replace(' ', '-').trim()
                // console.log(url)
                gruppenUrls.push(url)
                // gruppenUrls[`${url}`] = gruppe2[j]
              }
              // for (url in gruppenUrls) {
              //   console.log(url + ': ' + gruppenUrls[url])
              // }
              // set gruppenUrls
              commit('SET_GRUPPEN_URLS', gruppenUrls)
              // set for vegan gruppe
              // commit('SET_VEGAN')
              resolve()
            })
        }
      )
    },
    setProductToStore ({ commit, getters }) {
      return new Promise(
        (resolve) => {
          // set of the store_id
          commit('SET_STORE_ID', shop2[0].restaurant_id)
          // set the products
          commit('SET_PRODUCTS', shop2)
          var gruppe = ['Home', 'Vorspeise', 'Haupt Gerichte', 'Getr&#228;nke', 'Salate', 'Suppe', 'Vegan', 'Vegetarisch', 'Nicht-vegetarisch']
          var rabbatExists = false
          var gruppe1 = []
          for (var i = 0; i < shop2.length; ++i) {
            if (shop2[i].inventory) {
              // here stats the code

              // here
              var tempGruppe = shop2[i].gruppe
              // find out if it is a lunch time
              var decrease = 0
              // console.log(getters.getIsLunchTime)
              if (getters.getIsLunchTime) {
                decrease = shop2[i].lunch_price_decrease
                console.log(decrease)
              // curPrice + curPrice * this.product.lunch_price_decrease/ 100
              } else {
                decrease = shop2[i].dinner_price_decrease
                // console.log(decrease)
              }
              // now check if decrease
              if (decrease <= 0) {
                for (var j = 0; j < tempGruppe.length; ++j) {
                  if (tempGruppe[j] === 'Rabattaktion') {
                    tempGruppe.splice(j, 1)
                  }
                }
              } else {
                rabbatExists = true
              }
              // Here her
              if (gruppe1.length > 0) {
                gruppe1 = [...gruppe1, ...tempGruppe]
              } else {
                gruppe1 = tempGruppe
              }
              // console.log(gruppe1)
            }
          }
          if (rabbatExists) {
            gruppe.unshift('Rabattaktion')
          }
          gruppe1 = gruppe1.sort()
          if (gruppe.length > 0) {
            gruppe = [...gruppe, ...gruppe1]
          } else {
            gruppe = gruppe1
          }
          var gruppe2 = gruppe.filter((item, index) => gruppe.indexOf(item) === index)
          // console.log(gruppe2)
          commit('SET_GRUPPE', gruppe2)
          // create gruppen Urls
          var gruppenUrls = []
          for (j = 0; j < gruppe2.length; ++j) {
            var url = gruppe2[j].replace(' ', '-').trim()
            // console.log(url)
            gruppenUrls.push(url)
            // gruppenUrls[`${url}`] = gruppe2[j]
          }
          // for (url in gruppenUrls) {
          //   console.log(url + ': ' + gruppenUrls[url])
          // }
          // set gruppenUrls
          commit('SET_GRUPPEN_URLS', gruppenUrls)
          // console.log(shop2)
          resolve()
        })
    },
    decrease_price ({ state }, product) {
      var decrease = 0.00
      if (state.isLunchTime) {
        decrease = product.lunch_price_decrease
        // curPrice + curPrice * this.product.lunch_price_decrease/ 100
      } else {
        decrease = product.dinner_price_decrease
        // console.log(increase)
      }
      return decrease
    },
    setDeleveryCost ({ getters, state, commit }, deleveryCost) {
      if (state.form.getCartTotal < 35) {
        commit('SET_DELEVERY_COST', deleveryCost)
      } else {
        commit('SET_DELEVERY_COST', 0)
      }
      commit('SET_CART_TOTAL', getters.getCartTotal)
    }
  },
  modules: {
  }
})
